import { queryOptions } from "@tanstack/react-query";
import type { WebStudioScope } from "../../api/boot";
import type { WebStudioCloudApiClient } from "../../api/generatedClient";
import { loadTemplateCatalog, loadWorkspaceCatalog } from "../../api/workspaces";

/**
 * TanStack Query option factories for the workspace/worldview/template
 * READ family (workspace catalog, template catalog). Keys carry cache
 * identity only — the scope selection plus the explicit refresh
 * generation; all semantics (selection states, transition state, signed
 * catalog identity) stay inside the generated responses. Selection and
 * creation (`selectWorkspace`, `selectWorldview`,
 * `selectWorkspaceEnvironment`, `createWorkspaceFromTemplate`) are
 * user-invoked TanStack mutations owned by the shell and route
 * composers, never queries.
 */
export interface WorkspaceQueryInput {
  generation?: number | undefined;
}

export function workspaceCatalogQueryOptions(
  client: WebStudioCloudApiClient,
  scope: WebStudioScope,
  input: WorkspaceQueryInput = {},
) {
  return queryOptions({
    queryKey: ["workspaces", "catalog", scope, input.generation ?? 0] as const,
    queryFn: ({ signal }) => loadWorkspaceCatalog(client, scope, { signal }),
  });
}

export function templateCatalogQueryOptions(
  client: WebStudioCloudApiClient,
  scope: WebStudioScope,
  input: WorkspaceQueryInput = {},
) {
  return queryOptions({
    queryKey: ["workspaces", "templates", scope, input.generation ?? 0] as const,
    queryFn: ({ signal }) => loadTemplateCatalog(client, scope, { signal }),
  });
}
